import {
  GET_REGIONAL_DATABASES_IN_PROGRESS,
  GET_REGIONAL_DATABASES_SUCCESS,
  GET_REGIONAL_DATABASES_FAILED
} from "./types";

export const getRegionalDatabasesInProgress = _ => ({
  type: GET_REGIONAL_DATABASES_IN_PROGRESS
});

export const getRegionalDatabasesSuccess = regional_databases => ({
  type: GET_REGIONAL_DATABASES_SUCCESS,
  regional_databases: regional_databases
});

export const getRegionalDatabasesFailed = _ => ({
  type: GET_REGIONAL_DATABASES_FAILED
});
